import { Box, Flex, Label1 } from '@sainsburys-tech/fable'
import { Tick } from '@sainsburys-tech/icons'
import React from 'react'

import ICounterCheck from '../../types/ICounterCheck'
import {
  afternoonHour,
  getCurrentCheckedTimeInOrder,
  getNextTimeToCheck,
  getTimeNow,
  midday,
  midnight,
} from '../../utils/hotFoodUtils'

interface IPostSubmitMessageCard {
  counters: ICounterCheck[]
  isInstantMessage: boolean
}

const PostSubmitMessageCard = (props: IPostSubmitMessageCard): JSX.Element => {
  const renderMessage = () => {
    const latestTakenTime = getCurrentCheckedTimeInOrder(props.counters)

    // General message after AM check
    const timeToCheck = getNextTimeToCheck(props.counters)
    const message =
      !props.isInstantMessage && timeToCheck.isSame(midday)
        ? // Current is AM, and AM check was done
          ''.concat(
            "You've already completed your AM temperature check.",
            '\n',
            'Please wait until 12:00 to complete your PM check.',
          )
        : !props.isInstantMessage && timeToCheck.isSame(midnight)
          ? // Current is PM, and AM/PM checks were done
            ''.concat(
              'AM and PM checks have been completed.',
              '\n',
              'You have no more turbo-serve checks due today.',
            )
          : // general message after temp check
            ''.concat(
              'Temperature readings submitted at ',
              latestTakenTime.format('HH:mm'),
              '.',
              getTimeNow().getHours() >= afternoonHour
                ? ''
                : `\nPlease complete your next check at ${timeToCheck.format('HH:mm')}.`,
            )

    return message.split('\n').map((line, i) => (
      <div key={i}>
        {line}
        <br />
      </div>
    ))
  }

  return (
    <Box
      className='hotfood-counter-batch-card-wrapper'
      backgroundColor='secondary'
    >
      <Flex
        direction='row'
        alignItems='center'
        justifyContent='left'
        gap='md'
        style={{ width: '100%' }}
      >
        <Tick
          style={{
            width: '1.25rem',
            height: '1.25rem',
            display: 'inline-block',
            verticalAlign: 'middle',
            color: 'var(--fable-color-background-success-bold)',
          }}
        />
        <div
          data-testid='post-submission-message'
          style={{
            width: '100%',
            textAlign: 'center',
          }}
        >
          <Label1>{renderMessage()}</Label1>
        </div>
      </Flex>
    </Box>
  )
}

export default PostSubmitMessageCard
